import { ReactComponent as FullScreenIcon } from "components/icons/fullScreenIcon.svg";
import { ReactComponent as SimpleScreenIcon } from "components/icons/simpleScreenIcon.svg";
import "./FSButton.scss";

interface IFSButtonProps {
  onClick: () => void;
  fullscreen: boolean;
}

export const FSButton: React.FC<IFSButtonProps> = ({
  onClick,
  fullscreen
}) => {
  return (
    <button onClick={onClick} className="FSButton">
      {fullscreen ? <SimpleScreenIcon /> : <FullScreenIcon />}
    </button>
  );
};
